// Billing Report Bar Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface BillingReportBarChartProps {
  reportData: Array<{
    meterId: string;
    requestsReceived: number;
    readsShared: number;
    [key: string]: any;
  }>;
}

const BillingReportBarChart: React.FC<BillingReportBarChartProps> = ({
  reportData,
}) => {
  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      axisPointer: { type: "line" },
      formatter: (params: any) => {
        let tooltipContent = `
      <div style="padding: 5px 10px; border-radius: 3px; color: #ffffff;">
        <b>${params[0].axisValue}</b><br/>
    `;

        params.forEach((item: any) => {
          tooltipContent += `
        <div style="margin-top: 5px;">
          ${item.seriesName}: ${item.value}
        </div>
      `;
        });

        tooltipContent += `</div>`;
        return tooltipContent;
      },
    },

    xAxis: {
      type: "category",
      name: "Meters",
      position: "bottom",
      data: reportData?.map((item) => item.meterId),
      axisLabel: {
        color: "#5F6368",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
    },
    yAxis: [
      {
        type: "value",
        name: "Count",
        position: "left",
        axisLabel: {
          formatter: "{value}",
          color: "#5F6368",
          fontSize: 10,
          fontWeight: 400,
        },
        min: 0,
        max: 1000,
        interval: 200,
      },
    ],
    series: [
      {
        name: "Requests Received",
        type: "bar",
        data: reportData?.map((item) => ({
          value: item.requestsReceived,
        })),
        itemStyle: {
          color: "#1976d2",
        },
        barWidth: "30%",
      },
      {
        name: "Reads Shared",
        type: "bar",
        data: reportData?.map((item) => ({
          value: item.readsShared,
        })),
        itemStyle: {
          color: "#9CE976",
        },
        barWidth: "30%",
      },
    ],
    legend: {
      data: ["Requests Received", "Reads Shared"],
    },
    grid: {
      left: "3%",
      right: "5%",
      bottom: "20%",
      containLabel: true,
    },
  };
  return <ReactECharts option={options} style={{ height: "350px" }} />;
};

export default BillingReportBarChart;
